// extracted by mini-css-extract-plugin
export var container = "styles-module--container--67478";
export var grid = "styles-module--grid--017ff";